module.exports = __webpack_public_path__ + "img/gb951.prt.1ce61f46.jpg";